<script lang="ts">
  import {
    Grid,
    Row,
    Column,
    Form,
    TextInput,
    Button,
    InlineNotification,
  } from 'carbon-components-svelte'

  import { createEventDispatcher } from 'svelte'
  import type { LoginEvent } from '../events'
  import ConnectionStore from '../stores/connection'

  const dispatch = createEventDispatcher<{ doLogin: LoginEvent }>()

  export let initialUsername = ''
  export let initialHostname = ''
  export let initialPort = 0

  let username = initialUsername || ''
  let hostname = initialHostname || 'localhost'
  let port = `${initialPort}` || '1106'

  $: usernameInvalidText = !username.trim() ? 'Username is mandatory' : username.trim().length < 3 ? 'Username must be at least 3 letters long' : null
  $: hostnameInvalidText = !hostname.trim() ? 'Hostname is mandatory' : null
  $: portInvalidText = !port.trim() ? 'Port is mandatory' : isNaN(Number(port.trim())) ? 'Port must be a number' : null
  $: invalid = !!usernameInvalidText || !!hostnameInvalidText || !!portInvalidText

  let loginError: string | null
  ConnectionStore.onLoginError(({detail: { reason }}) => {
    if (reason === 'LOGIN_USERNAME_EXISTS') {
      loginError = 'Another player with the same username is already connected'
    } else if (reason === 'LOGIN_USERNAME_INVALID') {
      loginError = 'The givne username is invalid'
    } else if (reason === 'LOGIN_FAILED') {
      loginError = 'The server rejected the login'
    }
  })

  export let loggingIn: boolean

  $: if (loggingIn) {
    loginError = null
  }

  function establishConnection() {
    dispatch('doLogin', { username, hostname, port: Number(port) })
  }
</script>

<main>
  <Grid>
    <Row>
      <Column lg={16}>
        <!-- <Breadcrumb noTrailingSlash aria-label="Page navigation">
          <BreadcrumbItem href="/">Getting started</BreadcrumbItem>
        </Breadcrumb> -->
        <h1 style="margin-bottom: 1.5rem">Connect to Cardodrom</h1>
      </Column>
    </Row>
    <Row>
      <Column>
        <Form>
          <div style="margin-bottom: 2rem">
            <TextInput
              id="cardodrom-username"
              invalidText={usernameInvalidText}
              labelText="Username"
              placeholder="User53298"
              bind:value={username}
              invalid={!!usernameInvalidText} />
          </div>
          <div style="margin-bottom: 2rem">
            <TextInput
              id="cardodrom-username"
              invalidText={hostnameInvalidText}
              labelText="Hostname"
              placeholder="ghci.de"
              bind:value={hostname}
              invalid={!!hostnameInvalidText} />
          </div>
          <div style="margin-bottom: 2rem">
            <TextInput
              id="cardodrom-username"
              invalidText={portInvalidText}
              labelText="Port"
              placeholder="1106"
              bind:value={port}
              invalid={!!portInvalidText} />
          </div>
          {#if loginError}
            <div style="margin-bottom: 2rem">
              <InlineNotification
                kind="error"
                subtitle={loginError}
                title="Login Failed"
              />
            </div>
          {/if}
          <div style="margin-top: 2rem">
            <Button
              kind="primary"
              tabindex="0"
              type="submit"
              disabled={invalid || loggingIn}
              on:click={establishConnection}>
              Establish Connection
            </Button>
          </div>
        </Form>
      </Column>
    </Row>
  </Grid>
</main>
